import type { CSSProperties } from 'react';
import type { Fill, Shadow } from '@bannermatic/core';

export function fillToCss(fill: Fill | null | undefined): string | undefined {
  if (!fill) return undefined;
  switch (fill.type) {
    case 'solid':
      return fill.color;
    case 'linear': {
      const stops = [...fill.stops]
        .sort((a, b) => a.offset - b.offset)
        .map((s) => `${s.color} ${Math.round(s.offset * 1000) / 10}%`)
        .join(', ');
      return `linear-gradient(${fill.angle}deg, ${stops})`;
    }
    case 'radial': {
      const stops = [...fill.stops]
        .sort((a, b) => a.offset - b.offset)
        .map((s) => `${s.color} ${Math.round(s.offset * 1000) / 10}%`)
        .join(', ');
      return `radial-gradient(circle at center, ${stops})`;
    }
  }
}

/** Gradients must go to `background`/`background-image`; solids are safer as `background-color`. */
export function fillStyle(fill: Fill | null | undefined): CSSProperties {
  if (!fill) return {};
  if (fill.type === 'solid') return { backgroundColor: fill.color };
  return { backgroundImage: fillToCss(fill) };
}

export function boxShadow(shadow: Shadow | null | undefined): string | undefined {
  if (!shadow) return undefined;
  return `${shadow.x}px ${shadow.y}px ${shadow.blur}px ${shadow.color}`;
}

export function textShadow(shadow: Shadow | null | undefined): string | undefined {
  if (!shadow) return undefined;
  return `${shadow.x}px ${shadow.y}px ${shadow.blur}px ${shadow.color}`;
}
